<template>
    <cancel></cancel>

    <div class="spa">
        <div class="container">
            <div class="page-intro mb-0">
                <h1>BOOK A SPA DAY</h1>
            </div>

            <div class="mb-4">
                <spa-day-progress-bar></spa-day-progress-bar>
            </div>

            <div v-if="canShowBar">
                <spa-booking-summary v-bind:isSpaDay="true"></spa-booking-summary>

            </div>
        </div>
        <router-view></router-view>
    </div>
    
</template>
<script>
    import Cancel from '@/shared/components/Cancel.vue';
    import SpaDayProgressBar from '../components/SpaDayProgressBar.vue';
    import SpaBookingSummary from '../components/SpaBookingSummary.vue';


    export default {
        name: 'SpaDayBooking',
        components: {
            Cancel,
            SpaDayProgressBar,
            SpaBookingSummary
 
        },
        computed: {
            canShowBar() {
                let route = this.$route.name;
                var hidden = route === 'spa_day_search' || route === 'spa_day_guests' || route === 'spa_day_arrival_time'
                    || route === 'spa_day_details' || route === 'spa_day_summary' || route === 'spa_day_payment';

                return !hidden;

            }
        },

    }
</script>
<style src="@/css/booking/booking.css"></style>